import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center h-full" };
const _hoisted_2 = { class: "mr-1" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.action_items.owners')
};
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useStore } from 'vuex';
import { useRetroStore } from '@/pinia_stores/retro';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'ActionItemOwnersText',
    props: {
        item: null,
        editable: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const retroStore = useRetroStore();
        const { phase, users } = storeToRefs(retroStore);
        const { assignCurrentUserToActionItem } = retroStore;
        const sessionId = computed(() => store.getters.session.id);
        const userIsAssigned = computed(() => {
            return props.item.owners?.map((owner) => owner.userId).includes(sessionId.value);
        });
        const hasOwners = computed(() => props.item.owners?.length > 0);
        function handleAssign() {
            assignCurrentUserToActionItem(props.item.id);
        }
        return (_ctx, _cache) => {
            const _component_pill_button = _resolveComponent("pill-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(hasOwners)
                    ? _ctx.$tc('keep_the_team_accountable', __props.item.owners.length, {
                        name: _unref(users).find((user) => user.id === __props.item.owners[0].userId).name
                    })
                    : _unref(phase) === 'discussion'
                        ? _ctx.$t('keep_accountable_question')
                        : _ctx.$t('team_keep_in_mind')), 1),
                (__props.editable && !_unref(userIsAssigned))
                    ? (_openBlock(), _createBlock(_component_pill_button, {
                        key: 0,
                        size: "sm",
                        kind: "secondary",
                        onClick: handleAssign
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(hasOwners) ? 'assign_me_too' : 'i_will'}`)), 1)
                        ], undefined, true),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
